import * as React from "react";

function ItalineaLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={137.892} height={45.284} {...props}>
      <g data-name="Grupo 7581" fill="#fff">
        <path
          data-name="Caminho 7867"
          d="M42.014 34.192c-4.559 1.635-6.311 2.552-6.311 5.581a2.76 2.76 0 002.882 2.991c2.689 0 3.429-2.473 3.429-5.422zm7.633 10.258a19.45 19.45 0 01-4.346.734c-3.109.024-3.413-1.54-3.522-1.584-.076-.031-.119.005-.2.083-2.5 2.507-11.818 2.592-11.863-3.693-.03-4.08 2.788-4.961 7.269-6.278 4.831-1.395 5.025-1.395 5.025-3.946 0-2.511-.624-3.508-2.572-3.508-1.831 0-2.571 1.156-2.571 2.909a3.575 3.575 0 00.428 1.675 4.7 4.7 0 01-3.115 1.156 2.845 2.845 0 01-3.078-3.031c0-3.149 3.739-4.7 7.674-4.7 5.1 0 8.686 1.356 8.686 6.857v9.848c0 2.431.312 2.879 2.18 2.879z"
        />
        <path
          data-name="Caminho 7868"
          d="M130.259 34.192c-4.558 1.635-6.311 2.552-6.311 5.581a2.76 2.76 0 002.882 2.991c2.688 0 3.429-2.473 3.429-5.422zm7.633 10.258a19.441 19.441 0 01-4.345.734c-3.11.024-3.414-1.54-3.523-1.584-.076-.031-.119.005-.2.083-2.5 2.507-11.818 2.592-11.863-3.693-.031-4.08 2.789-4.961 7.269-6.278 4.83-1.395 5.025-1.395 5.025-3.946 0-2.511-.624-3.508-2.572-3.508-1.831 0-2.571 1.156-2.571 2.909a3.575 3.575 0 00.428 1.675 4.7 4.7 0 01-3.116 1.156 2.845 2.845 0 01-3.078-3.031c0-3.149 3.74-4.7 7.674-4.7 5.1 0 8.687 1.356 8.687 6.857v9.848c0 2.431.312 2.879 2.18 2.879z"
        />
        <path
          data-name="Caminho 7869"
          d="M5.472 23.494c0-3.389-.663-3.907-3.662-4.147v-.6h13.119v.6c-3 .24-3.663.758-3.663 4.147v16.117c0 3.39.663 3.907 3.663 4.147v.708H1.81v-.708c3-.24 3.662-.757 3.662-4.147z"
        />
        <path
          data-name="Caminho 7870"
          d="M28.221 27.135h-4.792v13.87c0 2.194.935 2.989 2.648 2.989a14.335 14.335 0 002.221-.278v.6a10.674 10.674 0 01-5.322.946c-3.811-.215-5.313-2.034-5.313-6.06v-12.07h-2.332v-.641c2.845-.757 5.895-2.515 6.965-6.5h1.136v5.933h4.789z"
        />
        <path
          data-name="Caminho 7871"
          d="M51.128 44.451v-.611c1.557-.08 2.337-.358 2.337-1.834V21.34c0-1.555-.78-1.914-2.337-1.994v-.6l8.1-.718v23.983c0 1.476.779 1.754 2.337 1.834v.609z"
        />
        <path
          data-name="Caminho 7872"
          d="M87.431 44.451v-.594c1.169-.078 1.947-.358 1.947-1.834V31.402c0-2.273-.895-3.469-2.8-3.469a4.407 4.407 0 00-3.117 1.6v12.489c0 1.475.779 1.755 1.948 1.834v.594h-9.817v-.594c1.325-.078 2.1-.358 2.1-1.834V28.65c0-1.554-.78-1.913-2.337-1.993v-.642l7.868-.717v1.718c0 .16.078.2.195.2s.194-.039.583-.4a7.8 7.8 0 015.611-2.552c4.361 0 5.531 3.189 5.531 7.814v9.944c0 1.475.779 1.755 2.1 1.834v.594z"
        />
        <path
          data-name="Caminho 7873"
          d="M110.001 30.561c-.238-2.221-1.017-4.509-3.328-4.3-3.3.294-3.757 4.654-3.44 7.429 0 0 4.4-.889 4.734-.97 2.236-.544 2.112-1.43 2.033-2.157m-6.434 6.409c.422 2.839 2.18 5.424 6.017 5.424 2.336 0 4.154-1.547 5.4-2.823l1.233 1.04c-1.713 2.832-4.6 4.769-9.154 4.574-6.687-.286-9.251-5.5-9.251-10.147 0-5.782 2.94-10.774 9.251-10.774 5.034 0 7.632 3.224 8.485 7.259.051.242.368 2.708-2.723 3.49-2.965.75-9.257 1.955-9.257 1.955z"
        />
        <path
          data-name="Caminho 7874"
          d="M65.525 24.527h.008c1.154-.268 3.359-.82 5.518-1.419a2.235 2.235 0 001.735-2.251 2.132 2.132 0 00-2.221-2.073 3.323 3.323 0 00-2.531 1.555l-2.827 3.683z"
        />
        <path
          data-name="Caminho 7875"
          d="M71.421 42.022v-16.7l-8.1.718v.615c1.558.08 2.338.439 2.338 1.993v13.373c0 1.475-.779 1.755-2.338 1.834v.594h10.44v-.594c-1.558-.078-2.338-.358-2.338-1.834"
        />
        <path
          data-name="Caminho 7876"
          d="M16.739 8.566A8.372 8.372 0 118.371 0a8.468 8.468 0 018.369 8.566"
        />
      </g>
    </svg>
  );
}

const MemoItalineaLogo = React.memo(ItalineaLogo);
export default MemoItalineaLogo;
